import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  type OnChanges,
  type OnInit,
  Output,
  type SimpleChanges,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { textVariants } from '@freelancer/ui/tailwind-text';
import { FontColor, TextAlign, TextSize } from '@freelancer/ui/text';
import { HowItWorksViewType } from 'app/how-it-works-page/how-it-works-page.types';

@Component({
  standalone: false,
  selector: 'app-upsell',
  template: `
    <fl-container
      class="Upsell"
      [class.Upsell--center]="alignment === TextAlign.CENTER"
    >
      <div
        class="Upsell-wrapper"
        [class.Upsell-wrapper--center]="alignment === TextAlign.CENTER"
      >
        <h2
          i18n="Upsell blade header"
          [class]="headingCls"
          [class.mb-mid]="true"
        >
          So what are you waiting for?
        </h2>
        <p
          [class]="cls"
          [class.tablet:mb-xlarge]="true"
          [class.mb-large]="true"
        >
          @if (viewType === HowItWorksViewType.CLIENT) {
            <ng-container i18n="Upsell description for employer view">
              Post a project today and get bids from talented freelancers.
            </ng-container>
          } @else {
            <ng-container i18n="Upsell description for freelancer view">
              Search for the right job and write your best bid proposal now.
            </ng-container>
          }
        </p>
        <fl-button
          [flTrackingLabel]="
            viewType === HowItWorksViewType.CLIENT
              ? 'PostProjectButton'
              : 'BrowseJobsButton'
          "
          [link]="
            disableLink
              ? undefined
              : viewType === HowItWorksViewType.CLIENT
                ? '/post-project'
                : '/jobs'
          "
          [color]="ButtonColor.PRIMARY"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          (click)="handlePostButtonClick()"
        >
          @if (viewType === HowItWorksViewType.CLIENT) {
            <ng-container i18n="Button text for posting a project">
              Post a Project
            </ng-container>
          } @else {
            <ng-container i18n="Button text for browsing jobs">
              Browse Jobs
            </ng-container>
          }
        </fl-button>
      </div>
    </fl-container>
  `,
  styleUrls: ['./upsell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellComponent implements OnInit, OnChanges {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  TextAlign = TextAlign;

  HowItWorksViewType = HowItWorksViewType;

  @Input() viewType = HowItWorksViewType.CLIENT;
  @Input() alignment = TextAlign.LEFT;
  @Input() disableLink = false;
  @Output() postButtonClicked = new EventEmitter<void>();

  cls: string;
  headingCls: string;

  handlePostButtonClick(): void {
    this.postButtonClicked.emit();
  }

  ngOnInit(): void {
    this.computeClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alignment) {
      this.computeClasses();
    }
  }

  private computeClasses(): void {
    this.cls = textVariants({
      align: this.alignment,
      size: TextSize.BODY_16,
      sizeTablet: TextSize.MID,
      sizeDesktop: TextSize.LARGE,
      color: FontColor.LIGHT,
    });

    this.headingCls = textVariants({
      color: FontColor.LIGHT,
      size: TextSize.XLARGE,
      sizeDesktop: TextSize.XXLARGE,
      align: this.alignment,
    });
  }
}
